import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom'
import Nav from './components/Nav'
import Footer from './components/Footer'
import Home from './pages/Home'
import OrderSelesai from './pages/OrderSelesai'
import CategoryList from './pages/CategoryList'
import SearchResults from './pages/SearchResults'
import ProductDetail from './pages/ProductDetail'
import CekStatusPesanan from './pages/CekStatusPesanan'
import Login from './pages/Login'
import Register from './pages/Register'
import Settings from './pages/Settings'
import MyOrder from './pages/MyOrder'
import Notifikasi from './pages/Notifikasi'
import Pesanan from './pages/Pesanan'
import Items from './pages/Items'
import SewaList from './pages/SewaList'
import JasaList from './pages/JasaList'
import { CartProvider } from './context/CartContext'
import { OrgProvider, useOrg } from './context/OrgContext'
import DevOrgSwitcher from './components/DevOrgSwitcher'

const DEFAULT_COLOR = '#2563eb'

function ThemeInjector() {
  const { org } = useOrg()
  useEffect(() => {
    const color = org?.primary_color || DEFAULT_COLOR
    document.documentElement.style.setProperty('--color-primary', color)
  }, [org?.primary_color])
  useEffect(() => {
    if (!org) return
    document.title = org.nama
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute('content', `Pesan produk dari ${org.nama} dengan mudah. Antar ke rumah Anda.`)
    }
  }, [org?.nama])
  return null
}

function PublicLayout() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 flex flex-col">
      <Nav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}

function NoMobileFooterLayout() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 flex flex-col">
      <Nav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer className="hidden md:block" />
    </div>
  )
}

export default function App() {
  return (
    <OrgProvider>
    <CartProvider>
      <ThemeInjector />
      {import.meta.env.DEV && <DevOrgSwitcher />}
      <BrowserRouter>
        <Routes>
          {/* Pages with Nav + Footer */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/kategori/:slug" element={<CategoryList />} />
            <Route path="/sewa" element={<SewaList />} />
            <Route path="/jasa" element={<JasaList />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/cek-pesanan" element={<CekStatusPesanan />} />
          </Route>

          {/* Pages with Nav, Footer hidden on mobile */}
          <Route element={<NoMobileFooterLayout />}>
            <Route path="/produk/:id" element={<ProductDetail />} />
            <Route path="/pesanan" element={<Pesanan />} />
            <Route path="/item" element={<Items />} />
            <Route path="/status" element={<OrderSelesai />} />
            <Route path="/my-order" element={<MyOrder />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/notifikasi" element={<Notifikasi />} />
          </Route>

          {/* Auth pages — no Nav/Footer */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
    </OrgProvider>
  )
}
